<template>
    <div class="text-center">
        <span v-if="data[fieldKey]" :class="`badge badge-pill p-2 ${getColorStatus} capitalize`">
            {{ getStatusLabel }}
        </span>
        <span v-else class="text-center">
            -
        </span>
    </div>
</template>

<script>
export default {
	name: 'StatusColumn',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		fieldKey: {
			type: String,
			default: 'status',
		},
	},
	data() {
		return {};
	},
	computed: {
		getStatusLabel() {
			return this.data?.[this.fieldKey]?.split('_').join(' ');
		},
		getColorStatus() {
			let statusClass = 'badge-danger';
			const status = this.data?.[this.fieldKey];
			if (status === 'completed' || status === 'outsource' || status === 'delivered' || status === 'paid') {
				statusClass = 'badge-success';
			} else if (status === 'bulky') {
				statusClass = 'badge-primary';
			} else if (status === 'private_order_full' || status === 'full_payment') {
				statusClass = 'badge-info';
			} else if (status === 'private_order_dp' || status === 'processing') {
				statusClass = 'badge-secondary';
			} else if (status === 'private_order_invoicing' || status === 'invoicing') {
				statusClass = 'badge-invoicing';
			} else if (status === 'instant') {
				statusClass = 'badge-instant';
			} else if (status === 'delivery') {
				statusClass = 'badge-delivery';
			} else if (status === 'bank_transfer') {
				statusClass = 'badge-transfer';
			} else if (status === 'pending') {
				statusClass = 'badge-pending';
			}

			return statusClass;
		},
	},
	methods: {
	},
};
</script>

<style lang="scss" scoped>
.capitalize {
	text-transform: capitalize;
}

.badge-pending {
	color: white;
	background-color: #f1c469;
}

.badge-delivery {
	color: white;
	background-color: #ff8c00;
}

.badge-instant {
	color: white;
	background-color: #ffc107;
}

.badge-transfer {
	color: white;
	background-color: #006dc7;
}

.badge-invoicing {
	color: white;
	background-color: #ff79b0;
}
</style>
